export const enClientPortalAnalysisPages = {
    analysis: {
        analysisPage: {
            metrics: {
                totalSelectedAssetsMarketValue: 'Total market value of selected assets',
                totalSelectedAssetsMarketRent: 'Total market rent of selected assets',
                selectedAssetsValueTrend: 'Market value trend of selected assets',
                selectedAssetsRentTrend: 'Market rent development of selected assets',
            },
            marketValueTrendTooltip:
                'The development compares the current total market value with the sum of market values from each selected asset’s preceding valuation. Assets whose preceding valuation contains no market value are included only in the current total. It remains independent of the selected chart period.',
            marketRentTrendTooltip:
                'The development compares the current total market rent with the sum of market rents from each selected asset’s preceding valuation. Assets whose preceding valuation contains no market rent are included only in the current total. It remains independent of the selected chart period.',
            metricTabsAriaLabel: 'Analysis metric',
            selectedAssetsMarketValueDevelopment: 'Market value development of selected assets',
            selectedAssetsMarketRentDevelopment: 'Market rent development of selected assets',
            summarySeriesLabel: 'Total',
        },
    },
}
